import React from 'react';
import styled from 'styled-components';
import { PaperBlurFitBtn } from '../../../shared/component/headless/button/BtnBody';
import { BlackFitBtnHeartbeat } from '../../../shared/component/headless/button/BtnBody';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { AlertType, AlertPosition, TextAlignment, SupportStatus, getSupportTypeLabel } from '../../../shared/enum/EnumRepository';
import MoleculeDescription from '../../../shared/component/molecule/MoleculeDescription';
import { formatTimeHM } from '../../../shared/util/timeInvertor/formatTimeHM';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { getAlertMessage } from '../../../shared/constants/alertMessages';
import { useAdminSupport } from '../../share/hook/useAdminSupport';
import { useLanguageStore } from '../../../shared/store/languageStore';


const SupportViewer: React.FC = () => {
  const { enqueueAlert } = useStandardAlertStore();
  const { activeSupport, deleteSupport, updateSupport } = useAdminSupport();
  const { user } = useAuth();
  const { language } = useLanguageStore();
  if (!activeSupport) return null;

  const handleResolvedSupport = async () => {
    if (!user) return;
    console.log("resolved support");
    await updateSupport(user.aui, { supportId: activeSupport.id, status: SupportStatus.SOLVED });
  };

  const handleDismissSupport = async () => {
    if (!user) return;
    console.log("dismissed support");
    await updateSupport(user.aui, { supportId: activeSupport.id, status: SupportStatus.DISMISSED });
  };

  const handleDeleteSupport = async () => {
    if (!user) return;
    const callback = async () => {
      await deleteSupport(user.aui, { supportId: activeSupport.id });
    }
    enqueueAlert({
      type: AlertType.CONFIRM,
      position: AlertPosition.TOP,
      content: getAlertMessage('CONFIRM_DELETE_SUPPORT_MESSAGE'),
      callBack: callback
    });
  };

  return (
    <SupportViewComp>
      <SupportInfoContainer>
        <Title>{activeSupport.title}</Title>
        <Info>{getSupportTypeLabel(activeSupport.type, language)}</Info>
        <Info>{activeSupport.aui}</Info>
        <Info>{formatTimeHM(activeSupport.createdAt)}</Info>
        <Info>{activeSupport.status}</Info>
        <MoleculeDescription
          value={activeSupport.message}
          StyledDescription={Description}
          alignment={TextAlignment.LEFT}
        />

      </SupportInfoContainer>
      <BtnContainer>
        <HeadlessBtn
          value={"Dismiss"}
          handleClick={handleDismissSupport}
          StyledBtn={BlackFitBtnHeartbeat}
        />
        <HeadlessBtn
          value={"Solved"}
          handleClick={handleResolvedSupport}
          StyledBtn={PaperBlurFitBtn}
        />
        <HeadlessBtn
          value={"Delete"}
          handleClick={handleDeleteSupport}
          StyledBtn={PaperBlurFitBtn}
        />
      </BtnContainer>
    </SupportViewComp>
  );
};


const SupportViewComp = styled.section`
  position: relative;
  width: 29vw;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: scroll; /* 넘칠 경우 스크롤 생성 */
  &::-webkit-scrollbar {
    display: none;
  }
  padding-right: 2px;
  padding-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const SupportInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: 4px;
  padding-bottom: 16px;

  gap: 2px;
`

const Title = styled.h2`
  width: 100%;
  height:28px;

  display: flex;
  align-items: center;
  
  padding-bottom: 1px;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_02_1};
`;

const Info = styled.div`
  height: 18px;
  padding-right:4px;
  margin-bottom: 1px;
  ${({ theme }) => theme.typography.Body_04};
`;

const Description = styled.div`
  padding: 6px 0 9px 0;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_03_2};
`

const BtnContainer = styled.div`
  position: absolute;
  right: 0px;
  bottom: 0.6vh;
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
`

export default SupportViewer;